<template>
    <div class="apn-banner" :style="{'background-image': `url(${bgImage})`}">
        <!-- <div class="bg-image"></div> -->
        <!-- <div class="apn-container">
            <vue-typer 
                :repeat='0'
                :pre-type-delay='500'
                :text='message.header' />
            <p v-if="message.content">{{$t(message.content)}}</p>
        </div> -->
    </div>
</template>

<script>
// import { VueTyper } from 'vue-typer'

export default {
    name: 'ApnBanner',
    components: {
        //   VueTyper,
    },
    props: {
        bgImage: {
            type: String,
            required: true,
        },
        message: {
            type: Object,
            required: true,
        }
    }
}
</script>

<style scoped lang="scss">
.apn-banner {
    // margin-top: var(--header-height);
    height: 420px;
    position: relative;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    @media (max-width: 1900px) {
        height: 380px;
        background-position: top;
    }

    @media (max-width: 1600px) {
        height: 340px;
        background-position: top;
    }

    @media (max-width: 1400px) {
        height: 300px;
        background-position: top;
    }

    @media (max-width: 1000px) {
        height: 250px;
        background-position: top;
    }

    @media (max-width: 800px) {
        height: 200px;
        background-position: top;
    }

    @media (max-width: 600px) {
        height: 0;
        padding-top: 33%;
    }

    @media (min-width: 992px) {
        // background-size: auto 180%;
        background-position: top;
    }

    // .bg-image {
    //     position: absolute;
    //     z-index: 0;
    //     top: 0;
    //     left: 0;
    //     width: 100%;
    //     height: 100%;
    //     background-image: linear-gradient(#fffb, #fffb);
    //     @media (min-width: 992px) {
    //         background-image: linear-gradient(to right, #f4f4f4ff 45%, #f4f4f40f 100%);
    //     }
    // }
    
    .apn-container {
        height: 100%;
        display: flex;
        position: relative;
        z-index: 1;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding: 20px;
        * {
            max-width: 340px;
            margin: 0;
            padding: 0;
            @media (min-width: 992px) {
                max-width: 465px;
            }
        }
        h1, .vue-typer {
            font-size: 28px;
            line-height: 32px;
            font-weight: 300;
            @media (min-width: 992px) {
                font-size: 38px;
                line-height: 42px;
            } 
        }
        p {
            padding-top: 10px;
            font-weight: 400;
            @media (min-width: 992px) {
                font-weight: 300;
            } 
        }
    }
}
</style>
